import { ApiBaseService, api } from './ApiBaseService';

export interface CompletionLogRow {
  id: string;
  companyId: string | null;
  userId: string;
  userName?: string;
  model: string;
  provider: string;
  stream: boolean;
  status: number;
  errorCode: string | null;
  inputTokens: number;
  outputTokens: number;
  cost: number;
  fluxInputTokens: number;
  fluxOutputTokens: number;
  latencyMs: number;
  correlationId: string | null;
  createdAt: string;
}

export type LogSource = 'hot' | 'cold' | 'merged';

export interface CompletionLogsPage {
  data: CompletionLogRow[];
  nextCursor: string | null;
  source: LogSource;
}

export interface CompletionLogsQueryParams {
  userId?: string;
  model?: string;
  provider?: string;
  status?: 'ok' | 'error';
  from?: string;
  to?: string;
  cursor?: string;
  limit?: number;
}

const BASE = '/completions';

function buildQueryString(params: CompletionLogsQueryParams): string {
  const qs = new URLSearchParams();
  if (params.userId) qs.set('userId', params.userId);
  if (params.model) qs.set('model', params.model);
  if (params.provider) qs.set('provider', params.provider);
  if (params.status) qs.set('status', params.status);
  if (params.from) qs.set('from', params.from);
  if (params.to) qs.set('to', params.to);
  if (params.cursor) qs.set('cursor', params.cursor);
  if (params.limit !== undefined) qs.set('limit', String(params.limit));
  return qs.toString();
}

class CompletionLogsService {
  static async query(params: CompletionLogsQueryParams): Promise<CompletionLogsPage> {
    return ApiBaseService.get<CompletionLogsPage>(`${BASE}/logs?${buildQueryString(params)}`);
  }

  static async exportCsv(params: Omit<CompletionLogsQueryParams, 'cursor' | 'limit'>): Promise<void> {
    const response = await api.get(`${BASE}/logs/export?${buildQueryString(params)}`, {
      responseType: 'blob',
    });
    const blob = new Blob([response.data], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'completion-logs.csv';
    anchor.click();
    URL.revokeObjectURL(url);
  }
}

export default CompletionLogsService;
